export const ADD_VIEW_DATA = 'ADD_VIEW_DATA';

export const ADD_MENU_ITEM = 'ADD_MENU_ITEM';

export const ADD_CATEGORIES = 'ADD_CATEGORIES';

export const ADD_SUBCATEGORIES = 'ADD_SUBCATEGORIES';
